import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    summaryData: {
        totalTransaction: {
            fuelAmount: 0,
            fuelVolume: 0,
            transactionCount: 0,
        },
        totalSubsidyTransaction: {
            fuelAmount: 0,
            fuelVolume: 0,
            transactionCount: 0,
            collectedAmount: 0,
            totalNetSalesAmount: 0,
        },
        payments: [],
        subsidyMethod: [],
        regions: [],
        outlets: [],
        totalClawback: 0,
    },
    chartColors: ['#FDB924', '#00B1A9'],
    subsidyTypeFilter: null,
    fuelTypeFilter: 'ron95',
    fuelFilter: null,
};

const getters = {
    paymentTableData: state => {
        return state.summaryData.payments.map(payment => [
            payment.name,
            payment.transactionCount - payment.subsidyTransactionCount,
            payment.subsidyTransactionCount,
            payment.transactionCount,
            payment.fuelAmount - payment.subsidyFuelAmount,
            payment.subsidyFuelAmount,
            payment.fuelAmount,
            payment.fuelVolume - payment.subsidyFuelVolume,
            payment.subsidyFuelVolume,
            payment.fuelVolume,
        ]);
    },
    regionTableData: state => {
        return state.summaryData.regions.map(data => [
            data.name,
            data.transactionCount - data.subsidyTransactionCount,
            data.subsidyTransactionCount,
            data.transactionCount,
            data.fuelAmount - data.subsidyFuelAmount,
            data.subsidyFuelAmount,
            data.fuelAmount,
            data.fuelVolume - data.subsidyFuelVolume,
            data.subsidyFuelVolume,
            data.fuelVolume,
        ]);
    },
    outletTableData: state => {
        return state.summaryData.outlets.map(data => [
            data.name,
            data.transactionCount - data.subsidyTransactionCount,
            data.subsidyTransactionCount,
            data.transactionCount,
            data.fuelAmount - data.subsidyFuelAmount,
            data.subsidyFuelAmount,
            data.fuelAmount,
            data.fuelVolume - data.subsidyFuelVolume,
            data.subsidyFuelVolume,
            data.fuelVolume,
        ]);
    },
    subsidyMethodChartData: state => {
        return state.summaryData.subsidyMethod.map(v => ({
            name: v.name,
            value: v.transactionCount,
        }));
    },
    paymentMethodChartData: state => {
        const result = {
            labels: [],
            series: {
                'Non Subsidy': [],
                Subsidy: [],
            },
            total: [],
        };

        for (const payment of state.summaryData.payments) {
            result.labels.push(payment.name);
            result.series['Non Subsidy'].push(
                payment.transactionCount - payment.subsidyTransactionCount,
            );
            result.series['Subsidy'].push(payment.subsidyTransactionCount);
            result.total.push(payment.transactionCount);
        }

        return result;
    },
    totalClawback: state => state.summaryData.totalClawback || 0,
};

const mutations = {
    [type.SET_BUDI_SUMMARY](state, summaryData) {
        state.summaryData = summaryData;
    },
    [type.SET_BUDI_SUBSIDY_TYPE_FILTER](state, subsidyTypeFilter) {
        state.subsidyTypeFilter = subsidyTypeFilter;
    },
    [type.SET_BUDI_FUEL_FILTER](state, fuelFilter) {
        state.fuelFilter = fuelFilter;
    },
    [type.SET_BUDI_FUEL_TYPE_FILTER](state, fuelTypeFilter) {
        state.fuelTypeFilter = fuelTypeFilter;
    },
};

const actions = {
    getSummary({ commit, dispatch, state, rootState }) {
        startLoading(dispatch, 'fetch-budi-summary-data');

        let options = {
            since: rootState.report.startDate.format(),
            until: rootState.report.endDate.format(),
            ...(state.subsidyTypeFilter && {
                subsidyType: state.subsidyTypeFilter,
            }),
            fuelType: state.fuelTypeFilter,
            ...(state.fuelFilter && {
                fuel_id: state.fuelFilter,
            }),
            outlet_id: rootState.report.activeOutlet,
        };

        let api = Laroute.route('franchise.report.budi_summary.summary');

        axios
            .get(api, { params: options })
            .then(res => {
                endLoading(dispatch, 'fetch-budi-summary-data');

                commit(type.SET_BUDI_SUMMARY, res.data);

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-budi-summary-data');
                const message =
                    (err.response &&
                        err.response.data &&
                        err.response.data.message) ||
                    'Failed to fetch budi summary data.';
                toastr.error(message);
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/budi-summary.js